<template>
  <div class="box mb-0 is-flex is-align-items-center">
    <div class="media is-flex-grow-1">
      <div class="media-left">
        <div
          class="icon is-stamp"
          :class="`is-${color}`"
        >
          <i
            class="mdi"
            :class="`mdi-${icon}`"
          />
        </div>
      </div>
      <div class="media-content">
        <slot />
      </div>
    </div>
    <div
      v-if="hasRightIcon"
      class="icon"
    >
      <i class="mdi mdi-chevron-right" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
      type: String
    },
    color: {
      default: "primary",
      type: String
    },
    hasRightIcon: {
      default: true,
      type: Boolean
    }
  }
};
</script>
